<template>
  <div>
    <v-card>
      <div
        v-if="this.$route.name === 'SsoWelcome'"
        class="d-flex align-center px-10"
        style="min-height: 150px; justify-content: space-between"
      >
        <div class="d-flex align-center" style="min-height: 150px">
          <RouterLink :to="{ name: 'AdminSignIn' }" class="d-flex" style="align-items: center">
            <img src="./../assets/service-me-logo.png" style="max-height: 40px" />
          </RouterLink>
        </div>
        <div class="d-flex justify-end">
          <v-btn class="adminbutton" @click="triggerLogout"><v-icon class="mr-2">mdi-logout</v-icon>Log out</v-btn>
        </div>
      </div>
      <div v-else class="header-grid justify-between align-center px-10">
        <div class="header-left d-flex">
          <RouterLink :to="{ name: 'AdminSignIn' }" class="d-flex" style="align-items: center">
            <img src="./../assets/service-me-logo.png" style="max-height: 40px" />
          </RouterLink>
        </div>
        <div class="header-center d-flex justify-center pa-4">
          <div>
            <div
              class="justify-center"
              :class="isOwner || issuperadministrator ? 'organization-workspace-nav-bar' : 'workspace-nav-bar'"
            >
              <v-select
                v-if="isOwner || issuperadministrator"
                :items="organizationitems"
                v-model="selectedOrganization"
                item-title="name"
                item-value="id"
                label="Choose organization"
                solo
                return-object
                style="margin-right: 12px"
              ></v-select>
              <v-select
                :items="workspaceitems"
                v-model="selectedWorkspace"
                item-title="name"
                item-value="id"
                return-object
                label="Choose workspace"
                solo
                style="margin-right: 12px"
              ></v-select>
            </div>
            <div class="justify-center" style="display: grid; grid-template-columns: 25% 25% 25% 25%">
              <v-btn to="/issues" style="margin-right: 12px">
                <template v-slot:prepend>
                  <v-icon>mdi-check-circle</v-icon>
                </template>
                Issues
              </v-btn>
              <v-btn :to="{ name: 'QrCode' }" style="margin-right: 12px">
                <template v-slot:prepend>
                  <v-icon>mdi-qrcode</v-icon>
                </template>
                Qr Codes
              </v-btn>
              <v-btn to="/inventories" style="margin-right: 12px">
                <template v-slot:prepend>
                  <v-icon>mdi-pencil</v-icon>
                </template>
                Inventory
              </v-btn>
              <v-btn to="/statistics" style="margin-right: 12px">
                <template v-slot:prepend>
                  <v-icon>mdi-chart-line</v-icon>
                </template>
                Statistics
              </v-btn>
            </div>
          </div>
        </div>
        <div class="header-right col-md-3 d-flex justify-end">
          <div class="d-flex flex-column">
            <v-btn class="adminbutton mb-8" @click="triggerLogout" prepend-icon="mdi-logout">Log out</v-btn>
            <v-menu offset-y>
              <template v-slot:activator="{ props }">
                <v-btn class="adminbutton" v-bind="props" prepend-icon="mdi-cog">Admin</v-btn>
              </template>
              <v-list>
                <v-list-item link v-for="(item, index) in menuitems" :key="index" router :to="item.url">
                  <v-list-item-title class="menuitems">
                    <v-icon>
                      {{ item.icon }}
                    </v-icon>
                    {{ item.title }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </div>
      </div>
    </v-card>
    <div class="w-100" style="position: relative">
      <v-progress-linear v-if="loading" :indeterminate="loading" absolute="" color="#572F7B"></v-progress-linear>
    </div>
  </div>
</template>
<script>
import { HTTP } from "@/plugins/backendAPI";
import { mapGetters } from "vuex";
import { logout } from "../helpers/logoutHandler";
// import { EventBus } from '@/store/event-bus.js';

export default {
  data() {
    return {
      menuitems: [],
      selectedOrganization: null,
      selectedWorkspace: undefined,
    };
  },
  created() {
    this.getEverything();
  },
  computed: {
    ...mapGetters([
      "workspaceid",
      "useForms",
      "legacyworkspaceid",
      "workspaceitems",
      "organizationid",
      "organizationitems",
      "isadministrator",
      "issuperadministrator",
      "resetSelectedOrganizationAndWorkspace",
      "isOwner",
      "loading",
    ]),
  },
  watch: {
    selectedOrganizationId(newOrg) {
      if (newOrg && newOrg.id) {
        this.$store.dispatch("setOrganizationId", newOrg.id);
      }
    },
    useForms() {
      this.menuitems = [];
      this.fillmenuitems();
    },
    selectedWorkspace(newWorkspace) {
      if (newWorkspace === null) {
        this.$store.dispatch("saveWorkspaceId", -1);
      } else {
        this.$store.dispatch("saveWorkspaceId", newWorkspace.id);
      }
    },
    selectedOrganization(newOrganization) {
      this.$store.dispatch("saveOrganizationId", newOrganization.id);
      this.setSelectedOrganization(newOrganization.id);
      if (this.isOwner) {
        this.logOwnerActiveUserMetric();
      }
    },
    resetSelectedOrganizationAndWorkspace() {
      this.getEverything();
    },
  },
  methods: {
    updateOrganization(newOrg) {
      if (newOrg && newOrg.id) {
        this.$store.dispatch("setOrganizationId", newOrg.id);
        localStorage.setItem("organizationid", newOrg.id);
      }
    },

    async triggerLogout() {
      this.$store.dispatch("setLoading", true);
      await logout().catch(console.error);
      this.$store.dispatch("setLoading", false);
    },
    goToHome() {
      this.$store.dispatch("setLoading", true);
      this.$router.push("/");
      this.$store.dispatch("setLoading", false);
    },
    async getEverything() {
      this.getorganizations();
      this.getworkspaces();
    },
    fillmenuitems() {
      if (this.issuperadministrator) {
        this.menuitems.push({ title: "Organizations", icon: "mdi-domain", url: "/organizations" });
        this.menuitems.push({
          title: "System Inventory Types",
          icon: "mdi-dresser-outline",
          url: "/system-inventory-types",
        });
      }
      if (this.isadministrator || this.issuperadministrator) {
        this.menuitems.push({ title: "Organization Users", icon: "mdi-account", url: "/users" });
        this.menuitems.push({ title: "Workspaces", icon: "mdi-sitemap", url: "/workspaces" });
      }
      this.menuitems.push({ title: "QR categories", icon: "mdi-devices", url: "/qr-categories" });
      this.menuitems.push({ title: "Locations", icon: "mdi-home-map-marker", url: "/locations" });
      if (this.useForms) {
        this.menuitems.push({ title: "Forms", icon: "mdi-format-list-numbered", url: "/forms" });
      }
    },
    async getorganizations() {
      this.$store.dispatch("setLoading", true);
      this.$store.dispatch("clearOrganizationitems");
      if (this.organizationitems.length < 1) {
        await HTTP.get("/organization/get/simple")
          .then((response) => {
            if (response.data.length > 0) {
              response.data.forEach((element) => {
                this.$store.dispatch("addOrganizationitem", element);
              });
              const localStorageOrganizationIdExists = response.data.find((w) => w.id === Number(this.organizationid));
              if (!localStorageOrganizationIdExists) {
                this.selectedOrganization = response.data[0];
              } else {
                this.selectedOrganization = localStorageOrganizationIdExists;
              }
            }
            this.menuitems = [];
            this.fillmenuitems();
          })
          .catch(() => {})
          .finally(() => {
            this.$store.dispatch("setLoading", false);
          });
      }
    },
    async getworkspaces() {
      this.$store.dispatch("clearWorkspaceitems");
      if (this.workspaceitems.length < 1 && this.organizationid > 0) {
        await HTTP.get("/workspace/getlist/" + this.organizationid)
          .then((response) => {
            this.$store.dispatch("saveLegacyWorkspaceId", response.data.legacyWorkspaceId);
            if (response.data.workspaces.length === 0) {
              this.selectedWorkspace = null;
            } else {
              response.data.workspaces.forEach((element) => {
                this.$store.dispatch("addWorkspaceitem", element);
              });
              const localStorageWorkspaceIdExists = response.data.workspaces.find((w) => w.id == this.workspaceid);
              if (!localStorageWorkspaceIdExists) {
                this.selectedWorkspace = response.data.workspaces[0];
              } else {
                this.selectedWorkspace = localStorageWorkspaceIdExists;
              }
            }
          })
          .catch(() => {});
      }
    },
    // eslint-disable-next-line no-unused-vars
    setSelectedOrganization(organizationid) {
      this.$store.dispatch("setLoading", true);
      HTTP.get(`/organization/form/c/${organizationid}`)
        .then((response) => {
          this.$store.dispatch("doesOrganizationUseForms", response.data);
          if (!response.data && (this.$route.name === "FeedbackForm" || this.$route.name === "ContactRequestForm")) {
            this.$store.dispatch(
              "showError",
              "Your organization has disabled forms. <br><br> Redirecting to issues page..."
            );
            this.$router.push({ name: "Issue" });
          }
          this.getworkspaces();
        })
        .catch((error) => {
          console.error("Error in setSelectedOrganization", error);
          this.$store.dispatch("doesOrganizationUseForms", false);
          if (this.$route.name === "FeedbackForm" || this.$route.name === "ContactRequestForm") {
            this.$store.dispatch(
              "showError",
              "Your organization has disabled forms. <br><br> Redirecting to issues page..."
            );
            this.$router.push({ name: "Issue" });
          }
        })
        .finally(() => {
          this.$store.dispatch("setLoading", false);
        });
    },
    logOwnerActiveUserMetric() {
      this.$store.dispatch("setLoading", true);
      HTTP.post(`/activeusermetrics/owner-activity/${this.organizationid}`)
        .finally(() => {
          this.$store.dispatch("setLoading", false);
        });
    }
  },
};
</script>
<style lang="css" scoped></style>
